import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import BadgeList from '@cas/components/tables/cells/badge-list/BadgeList';
import { EmptyCell } from '../../formatters/genericFormatters';

export const LibraryCompatibleDevicesRenderer = <T extends object>({
  value,
}: CustomCellRendererProps<T, string[]>): ReactElement | string => {
  return value?.length ? <BadgeList items={value} statusColor="neutral" /> : EmptyCell;
};

export default LibraryCompatibleDevicesRenderer;
